module.exports = __webpack_public_path__ + "static/media/dcdb-burger-mobile-en.e3c26ae7.jpg";